import { CustomTooltip } from '@AMIEWEB/Common';
import { Grid, Typography } from '@mui/material';
import { ComplianceStateProgressNotesHeader } from 'app/models/Placement/PlacementDetails';
import React from 'react'
import { makeStyles } from 'tss-react/mui';
import { Concatenate } from 'utils/string/string';
import ComplianceStatusProgressDocDeadline from './ComplianceStatusProgressDocDeadline';
import ComplianceStatusProgressComments from './ComplianceStatusProgressComments';

type ComplianceStatusProgressHeaderProps = {
    complianceStateProgressNotesHeader: ComplianceStateProgressNotesHeader,
    fullScreen: boolean;
}
const useStyles = makeStyles<{ fullScreen: boolean }>()((theme, { fullScreen }) => ({
    headerContainer: {
        backgroundColor: theme.palette.system.white,
        overflow: 'hidden',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '12px 16px'
    },
    headerName: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: theme.palette.framework.system.charcoal
    },
    headerText: {
        fontSize: '14px',
        fontWeight: '400',
        display: fullScreen ? 'inline-block' : '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.palette.system.black
    },
}));

export default function ComplianceStatusProgressHeader({ complianceStateProgressNotesHeader, fullScreen }:
    ComplianceStatusProgressHeaderProps) {
    const { classes } = useStyles({ fullScreen });
    return (
        <Grid container className={classes.headerContainer}>
            <Grid item md={fullScreen ? 1 : 3}>
                <Typography className={classes.headerName}>{'Doc Deadline:'}</Typography>
            </Grid>
            <Grid item md={fullScreen ? 11 : 9} sx={{ display: fullScreen ? 'inline-block' : 'block' }}>
                <ComplianceStatusProgressDocDeadline
                    id={'docDeadline'}
                    docDeadline={complianceStateProgressNotesHeader.docDealine}
                    maxWidth={125}
                />
            </Grid>
            <Grid item md={fullScreen ? 1 : 3}>
                <Typography className={classes.headerName}>{'Order Reqs:'}</Typography>
            </Grid>
            <Grid item md={fullScreen ? 11 : 9} sx={{ display: fullScreen ? 'inline-block' : 'block' }}>
                {
                    complianceStateProgressNotesHeader.license.length > 0 ||
                        complianceStateProgressNotesHeader.certificates.length > 0 ?
                        <CustomTooltip
                            tooltipContent={Concatenate([...complianceStateProgressNotesHeader.license, ...complianceStateProgressNotesHeader.certificates], ', ')}
                            contentStyle={{
                                whiteSpace: 'normal',
                                display: fullScreen ? 'inline-block' : 'block'
                            }}
                        >
                            <div className={classes.headerText}>
                                {Concatenate([...complianceStateProgressNotesHeader.license, ...complianceStateProgressNotesHeader.certificates], ', ')}
                            </div>
                        </CustomTooltip> :
                        <div className={classes.headerText}>
                            {'-'}
                        </div>
                }
            </Grid>
            <Grid item md={fullScreen ? 1 : 3}>
                <Typography className={classes.headerName}>{'Comments:'}</Typography>
            </Grid>
            <Grid item md={fullScreen ? 11 : 9} sx={{ width: '260px' }}>
                <ComplianceStatusProgressComments
                    comments={complianceStateProgressNotesHeader.comments}
                    fullScreen={fullScreen}
                    saveStatus={complianceStateProgressNotesHeader.saveStatus}
                />
            </Grid>
        </Grid >
    )
}